export default __webpack_public_path__ + "static/media/d-iconArrowLeft2.fc629950.svg";